// extracted by mini-css-extract-plugin
module.exports = {"section":"TextSection_section__iBmyU","background_diamonds":"TextSection_background_diamonds__2bUqN"};